import type { InvoiceDate } from '@weft/types';
import { useStateParams } from '../../../../hooks/use-state-params';
import { DEFAULT_INVOICES_TABLE_SELECTED_MONTHS } from '../invoices-page-consts';

export function useDatesParam() {
  return useStateParams<InvoiceDate[]>(DEFAULT_INVOICES_TABLE_SELECTED_MONTHS, 'dates', serializeInvoiceDates, deserializeInvoiceDates);
}

function serializeInvoiceDates(dates: InvoiceDate[]) {
  return JSON.stringify(dates);
}

function deserializeInvoiceDates(datesString: string) {
  return JSON.parse(datesString);
}